<script>
  const crossIcon = "/assets_default/icons/cross.svg"
  let age = '';
  let salary = '';
  let debtNumber = '';
  let debtMoney = '';
  let showModal = false;
  let resultOK = false;

  const openModal = () => {
    const body = document.querySelector("body")
    body.style.overflow = !showModal ? 'hidden' : 'auto';
    showModal = !showModal;
  };

  const result = () => {
    resultOK = false;
    if (Number(debtNumber) < 5 && (Number(debtMoney) === 0 || Number(salary) > Number(debtMoney))) {
      resultOK = true;
    }
  };

  const resetSim = () => {
    age = '';
    salary = '';
    debtMoney = '';
    debtNumber = '';
  };

  const url = window.location.href;
  const parsedUrl = new URL(url);
  const pathSegments = parsedUrl.pathname.split('/');
  const relativepath = pathSegments[1];

  $: buttonReactive = !age || !salary || !debtNumber || (debtNumber !== '0' && !debtMoney);
  // $: buttonReactive = !age || !salary || !debtNumber || !debtMoney;
</script>

<div class="spacing:bottom:48">
  <div class="simulation-wrapper spacing:bottom:32" id="simulation-wrapper">
    <div class="simulation-container">
      <h2 class="sim-heading">
        <span class="owd-caption spacing:bottom:8"><strong>みんなの銀行ローン</strong></span>
        <span class="owd-text:01"><strong>借入れ診断</strong></span>
      </h2>

      <div class="sim-content">
        <div class="sim-content-input-item spacing:bottom:32">
          <p class="owd-caption"><strong>年齢</strong></p>
          <select bind:value={age} class={age.length === 0 ? "":"on-change"}>
            <option class="sim-content-inittext" disabled value="">選択してください</option>
            <option>20〜29歳</option>
            <option>30〜39歳</option>
            <option>40〜49歳</option>
            <option>50〜59歳</option>
            <option>60〜69歳</option>
          </select>
        </div>

        <div class="sim-content-input-item spacing:bottom:32">
          <p class="owd-caption"><strong>年収</strong></p>
          <select bind:value={salary} class={salary.length === 0 ? "":"on-change"}>
            <option disabled value="">選択してください</option>
            <option value="1">100万未満</option>
            <option value="2">100〜300万</option>
            <option value="3">300〜500万</option>
            <option value="4">500〜1000万</option>
            <option value="5">1000万以上</option>
          </select>
        </div>

        <div class="sim-content-input-item spacing:bottom:32">
          <p class="owd-caption"><strong>他社借入れ件数</strong></p>
          <select bind:value={debtNumber} class={debtNumber.length === 0 ? "":"on-change"}>
            <option disabled value="">件数を選択してください</option>
            <option value="0">0件</option>
            <option value="1">1件</option>
            <option value="2">2件</option>
            <option value="3">3件</option>
            <option value="4">4件</option>
            <option value="5">5件以上</option>
          </select>
        </div>

        <div class="sim-content-input-item spacing:bottom:16">
          <p class="owd-caption"><strong>他社借入れ金額</strong></p>
          <select bind:value={debtMoney} class={debtMoney.length === 0 ? "":"on-change"}>
            <option disabled value="">金額を選択してください</option>
            <option value="1">100万未満</option>
            <option value="2">100〜300万</option>
            <option value="3">300〜500万</option>
            <option value="4">500〜1000万</option>
            <option value="5">1000万以上</option>
          </select>
        </div>

        <ul class="owd-list:annotation spacing:bottom:32">
          <li>住宅ローン等の有担保ローンは含まず。</li>
        </ul>


        <div class="action-button-column">
          <button class="owd-button owd-button:small owd-button:secondary:white" on:click={resetSim}>リセット</button>
          <button class="owd-button owd-button:small owd-button:primary execution" disabled={buttonReactive} on:click={() => {openModal(); result();}} >
          診断開始
          </button>
        </div>
      </div>
      {#if showModal}
      <div class="owd-modal owd-modal:02 is-show">
          <div class="owd-modal-container">
            <button class="owd-modal-close" on:click={() => {openModal(); resetSim();}}>
              <div class="owd-modal-close:area">
                <img class="owd-modal-close:button" src={crossIcon} alt="クロスアイコン" data-owd-modal="closeButton">
              </div>
            </button>
            <div class="owd-modal:02-inner">
                <div class="align:center separate spacing:bottom:24">
                  <p class="owd-heading:03 spacing:bottom:24">借入れ診断結果</p>
                  {#if resultOK}
                    <div class="modal-result-answerbox spacing:bottom:24">
                      <p class="owd-text:01"><strong>ご融資可能と考えられます</strong></p>
                    </div>
                    <p class="owd-text:02 spacing:bottom:24">下記ボタンより申込みへお進みください。</p>
                    {:else}
                    <div class="modal-result-answerbox spacing:bottom:24 align:center not">
                      <p class="owd-text:01 spacing:bottom:16"><strong>申し訳ありません</strong></p>
                      <p class="owd-text:01">入力いただいた内容では判断できませんでした。</p>
                    </div>
                    <p class="owd-text:02 spacing:bottom:24 align:left">詳細な審査をご希望の場合は下記より申込みへお進みください。</p>
                  {/if}
                </div>
                <div class="spacing:bottom:32">
                  <div class="spacing:bottom:16 align:center">
                    <p class="owd-text:02"><strong>口座がない方は</strong></p>
                  </div>
                  <div class="spacing:bottom:16 block:center">
                    <a href="https://minna-no-ginko.go.link/92Gya" class="owd-button owd-button:large owd-button:primary">まずはアプリをダウンロード</a>
                  </div>
                  <ul class="owd-list:annotation">
                    <li>借入れ診断は、簡易的なもので結果を保証するものではございません。実際の申込みでは、詳細な内容に基づき審査いたします。ご希望にそえない場合もありますので、あらかじめご了承ください。</li>
                  </ul>
                </div>
                <p class="owd-text:02 align:center"><strong><button on:click={() => {openModal(); resetSim();}} class="owd-textlink">閉じる</button></strong></p>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>

  <div class="show:sp">
    <div class="spacing:bottom:16 block:center">
      <a href="https://minna-no-ginko.go.link/?tp=pg&pg=la&adj_t=1tzboi13" id="loan-apply-deep" class="owd-button owd-button:large owd-button:primary">ローンを申込む</a>
    </div>

    <div class="align:center">
      <p class="owd-information"><strong>※アプリをお持ちでない方は、ストアに遷移します。</strong></p>
    </div>
  </div>
</div>


<style lang="scss">
  .modal-result-answerbox {
    background: #ef0;
    padding: 32px 24px;
    &.not {
      background: #f4f4f4f4;
    }
  }
  .separate {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .simulation-container {
    // width: calc(100% - (24px * 2));
    width: 100%;
    max-width: 504px;
    margin: 0 auto;
    margin-top: 35px;
    position: relative;
  }

  .sim{
    &-heading {
      background: #000;
      color: #fff;
      padding: 12px 0;
      font-size: 24px;
      text-align: center;
      span{
        // font-size: 15px;
        color: #fff;
        display: block;
        // margin-bottom: 0;
      }
    }
    &-content {
      background: #f4f4f4f4;
      padding: 32px 20px;
      // border-radius: 0 0 8px 8px;
      &-input-item {
        padding: 0 0;
        // margin-bottom: 32px;
        border-bottom: 1px solid #000;
        &:last-child {
          margin-bottom: 0;
        }
        select {
          appearance: none;
          width: 100%;
          min-height: 0%;
          padding: 24px 0;
          font-size: 14px;
          background:url(/assets_default/icons/chevron_down.svg) calc(100% - 12px) 50% no-repeat;
          background-size: 24px 24px;
          text-align: left;
          color: var(--black-opacity7);
          font-family: g.$base-font;
          &.on-change {
            color: var(--primary-black);
          }
          &:focus-visible {
            outline: none;
          }
        }
        option {
          appearance: none;
          padding: 16px;
          font-size: 1.6rem;
          width: 100%;
        }
      }
    }
  }

  .action-button-column {
    display: grid;
    grid-template-columns: repeat(2,1fr);
    gap: 8px;
  }
  .execution {
    &:disabled {
      opacity: .2;
    }
  }

  // .modal{
  //   &-bg {
  //     position: fixed;
  //     top: 0;
  //     left: 0;
  //     background: rgba(0,0,0,.5);
  //     width: 100vw;
  //     height: 100vh;
  //   }
  //   &-container {
  //     width: 100vw;
  //     height: 100%;
  //     position: fixed;
  //     top: 0;
  //     left: 0;
  //     z-index: 4;
  //   }
  //   &-content {
  //     background: #fff;
  //     width: 95vw;
  //     max-width: 358px;
  //     position: absolute;
  //     top: 50%;
  //     left: 50%;
  //     transform: translate(-50%,-50%);
  //     max-height: 90vh;
  //     overflow-y: scroll;
  //     padding: 64px 24px 24px 24px;
  //     box-sizing: border-box;
  //   }
  //   &-close {
  //     position: absolute;
  //     top: 10px;
  //     right: 10px;
  //     // top: 26px;
  //     // right: 4px;
  //     appearance: none;
  //     border: 0;
  //     width: 18px;
  //     height: 18px;
  //     // height: 2px;
  //     background-color: transparent;
  //     cursor: pointer;
  //     &:before,&:after{
  //       content: "";
  //       position: absolute;
  //       top: 50%;
  //       width: 100%;
  //       height: 2px;
  //       background: #000;
  //       display: block;
  //       right: 0;
  //       // right: 16px;
  //     }
  //     &:before {
  //       transform: translateY(-50%) rotate(45deg);
  //     }
  //     &:after {
  //       transform: translateY(-50%) rotate(135deg);
  //       transition: .3s ease-out transform;
  //     }
  //   }
  // }
  </style>
